import { m, type MithrilVNode } from '../../mithril';
import { CSS } from './accordion.style';

export interface AccordionProps {
	title?: string | MithrilVNode;
	subtitle?: string | MithrilVNode;
	icon?: MithrilVNode;
	open?: boolean;
}

function view(props: AccordionProps, children: MithrilVNode[]): MithrilVNode {
	return m('details', { className: CSS.container, open: props.open || undefined, 'data-testid': 'accordion' }, [
		m('summary', { className: CSS.header, 'data-testid': 'accordion-header' }, [
			props.icon ?? null,
			m('span', [props.title, props.subtitle ? m('span', { className: CSS.subtitle }, [`(${props.subtitle})`]) : null]),
		]),
		m('div', { className: CSS.body }, children),
	]);
}

export const Accordion = { view, CSS };
